import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

export const getTrades = async (params = {}) => {
  const { 
    page = 1, 
    url: customUrl,
    top_trades_24h = false,
    top_pnl_24h = false,
    bet_value = null,
    user_address = null,
    market_slug = null,
    category = null,
  } = params;
  
  let finalUrl;

  if (customUrl) {
    finalUrl = customUrl;
  } else {
    const searchParams = new URLSearchParams();
    if (bet_value) searchParams.append('bet_value', bet_value);
    if (top_trades_24h) searchParams.append('top_trades_24h', 'True');
    if (top_pnl_24h) searchParams.append('top_pnl_24h', 'True');
    if (user_address) searchParams.append('user', user_address);
    if (market_slug) searchParams.append('market', market_slug);
    if (category) searchParams.append('category', category);
    
    const queryString = searchParams.toString();
    const frontendUrl = `/polymarket${queryString ? '?' + queryString : ''}`;
    finalUrl = `${window.location.origin}${frontendUrl}`;
  }

  const apiUrl = customUrl || `${backendUrl}/api/polymarket/trades/?page=${page}${finalUrl.includes('?') ? '&' + new URL(finalUrl).search.slice(1) : ''}`;
  const data = await fetchData(apiUrl);

  return {
    data,
    url: finalUrl
  };
};

const fetchData = async (url) => {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  
  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        `Ошибка при получении торговых операций: ${response.status} - ${errorData.message || response.statusText}`
      );
    }
    return await response.json();
  } catch (error) {
    console.error('Ошибка получения торговых операций:', error);
    throw error;
  }
};